module.exports = __webpack_public_path__ + "img/pengumuman.db126e9d.png";